<template>
    <b-col>
        <b-row>
            <b-col sm="12" md="4">
                <app-k-v
                    titulo="Número da Nota"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="despesa.numeroNota"
                ></app-k-v>
                <app-k-v
                    titulo="Sequencial"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="despesa.sequencial"
                ></app-k-v>
                <app-k-v
                titulo="Fornecedor"
                :md="md"
                :lg="lg"
                :xl="xl"
                >
                    <strong> {{ despesa.cpfCnpj }} - {{ despesa.nomeFornecedor }}</strong>
                </app-k-v>
                <app-k-v
                    titulo="Requisitante"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="despesa.nomeSolicitante"
                ></app-k-v>
                <app-k-v
                    titulo="Demandante"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="despesa.nomeDemandante"
                ></app-k-v>
                <app-k-v
                    titulo="Alçada da gerência"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                >
                    <app-status :status="despesa.alcadaGerencia ? 'SIM' : 'NÃO'"></app-status>
                </app-k-v>
                <app-k-v v-if="despesa.alcadaGerencia"
                    titulo="Autorizante"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="despesa.nomeAutorizante"
                ></app-k-v>
            </b-col>
            <b-col sm="12" md="4">
                <app-k-v
                    titulo="Data Emissão"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                >
                    <strong> {{ despesa.dataEmissao != null ? $moment(despesa.dataEmissao).format('DD/MM/YYYY') : '' }}  </strong>
                </app-k-v>
                <app-k-v
                    titulo="Data Movimento"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                >
                    <strong> {{ despesa.dataMovimento != null ? $moment(despesa.dataMovimento).format('DD/MM/YYYY') : '' }}  </strong>
                </app-k-v>
                <app-k-v
                    titulo="Data Vencimento"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                >
                    <strong> {{ despesa.dataVencimento != null ? $moment(despesa.dataVencimento).format('DD/MM/YYYY') : '' }}  </strong>
                    <btn-justificativa-data-vencimento
                        :despesa="despesa"
                    ></btn-justificativa-data-vencimento>
                </app-k-v>
                <app-k-v
                    titulo="Tipo Movimento"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="despesa.tipoMovimento.codNomeTipoMovimento"
                ></app-k-v>
                <app-k-v
                    v-if="interfaceDespesa"
                    titulo="Anexos"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                >
                    <strong>{{ despesa.qtdAnexos != null ? despesa.qtdAnexos : 0 }}</strong>
                </app-k-v>
                <app-k-v
                    v-if="interfaceDespesa"
                    titulo="Itens"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                >
                    <strong>{{ despesa.qtdItens != null ? despesa.qtdItens : 0 }}</strong>
                </app-k-v>
                <app-k-v
                    titulo="Valor"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                >
                    <strong> {{ despesa.valor | currency }}  </strong>
                </app-k-v>
            </b-col>
            <b-col sm="12" md="4">  
                <app-k-v
                    titulo="Boleto"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                >
                    <app-status :status="despesa.boleto ? 'SIM' : 'NÃO'"></app-status>
                </app-k-v>
                <app-k-v
                    titulo="Status"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                >
                    <app-status :status="despesa.status"></app-status>
                    <btn-msg-reprovacao
                        :despesa="despesa"
                    ></btn-msg-reprovacao>
                </app-k-v>
                <app-k-v
                    titulo="Comprometimento"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                >
                    <strong>{{ despesa.idMov }}</strong>
                    <status-id-mov
                        :despesa="despesa"
                    ></status-id-mov>
                    <btn-erro-comprometimento
                        :servicos="servicos"
                        :despesa="despesa"
                    ></btn-erro-comprometimento>
                    <btn-excluir-comprometimento
                        :despesa="despesa"
                        :servicos="servicos"
                        @obterAtualizacao="$emit('obterAtualizacao')"
                    ></btn-excluir-comprometimento>
                </app-k-v>
                <app-k-v
                    titulo="Histórico"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="despesa.historico"
                ></app-k-v>
                <div
                    v-if="temAvaliacao"
                >
                    <div v-for="(avaliacao, index) in despesa.ultimasAvaliacoes" :key="index">
                        <app-k-v
                            v-if="temResposta(avaliacao.resposta.toUpperCase())"
                            :titulo="avaliacao.pergunta"
                            :md="md"
                            :lg="lg"
                            :xl="xl"
                        >
                            <span 
                            >
                                <strong>{{ avaliacao.resposta.toUpperCase() }}</strong>
                            </span>
                        </app-k-v> 
                    </div>
                    <app-k-v
                        v-if="despesa.problema"
                        titulo="Problema"
                        :md="md"
                        :lg="lg"
                        :xl="xl"
                        :dado="despesa.problema"
                    ></app-k-v>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <despesa-time-line
                    :servicos="servicos"
                    :despesa="despesa"
                    v-if="mostrarTimeLine"
                ></despesa-time-line>
            </b-col>
        </b-row>
    </b-col>
</template>

<script>
import BtnMsgReprovacao from './BtnMsgReprovacao.vue';
import BtnErroComprometimento from './BtnErroComprometimento.vue';
import BtnExcluirComprometimento from './BtnExcluirComprometimento.vue';
import BtnJustificativaDataVencimento from './BtnJustificativaDataVencimento.vue';
import StatusIdMov from './StatusIdMov.vue';
import DespesaTimeLine from './DespesaTimeLine.vue';

export default {
    components: {
        BtnMsgReprovacao,
        BtnErroComprometimento,
        BtnExcluirComprometimento,
        BtnJustificativaDataVencimento,
        StatusIdMov,
        DespesaTimeLine
    },

    props: {
        despesa: {
            type: Object,
        },

        interfaceDespesa: {
            type: Boolean,
            default: () => true
        },

        servicos: {
            type: Object,
            default: () => ({})
        },

        mostrarTimeLine: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            xl: 4,
            lg: 4,
            md: 4,
            estiloResposta: {
                "RUIM": "text-danger",
                "REGULAR": "text-warning",
                "BOM": "text-success",
                "ÓTIMO": "text-primary"
            }
        }
    },

    computed: {
        temAvaliacao() {
            return this.despesa.ultimasAvaliacoes != null && this.despesa.ultimasAvaliacoes.length > 0
        }
    },

    methods: {
        temResposta(resposta) {
            return resposta.toUpperCase() != "NÃO SE APLICA"            
        },
    }
}

</script>